import { Experience, Product } from 'framework/products'

interface FazendinhaProduct {
  categorias: string
  descricao: string
  descricao_complementar: string
  id: number
  isAtacado: boolean
  assinatura: boolean
  assinatura_desconto_produtor?: number
  assinatura_frete_gratis?: number
  assinatura_desconto_frete?: number
  imagem_principal: string
  status: string
  imagens: Array<string>
  nome: string
  preco: string
  preco_promocional: string
  preco_promocional_ativo: boolean
  produtor: string
  produtor_id: number
  slug: string
  produtor_dias_entrega: string[]
  quantidade_estoque: number
  produtor_slug: string
  forma_entrega_slug: string
  tipo_produto: 'experiencia' | 'convencional'
  experiencias: any[]
  experiencia_entrada?: string
  experiencia_prato_principal?: string
  experiencia_bebidas?: string
  experiencia_sobremesa?: string
  experiencia_transporte?: string
  experiencia_localizacao?: string
  experiencia_aceita_animais?: string
  categorias_slug?: string[]
  tags_descricao?: string[] // force deploy
  isAfiliadoFavorite?: boolean
}

export default function parser(product: FazendinhaProduct): Product & { categories?: any; categorias_slug?: string[] } {
  return {
    id: product.id.toString(),
    assinatura: product.assinatura,
    assinatura_desconto_produtor: product.assinatura_desconto_produtor,
    assinatura_frete_gratis: product.assinatura_frete_gratis,
    assinatura_desconto_frete: product.assinatura_desconto_frete,
    slug: product.slug || 'erro',
    name: product.nome,
    description: product.descricao,
    status: product.status,
    image: product.imagem_principal,
    images:
      product.imagens?.length > 0
        ? product.imagens.map((url) => ({
            url: url !== undefined && url !== null ? url : '',
          }))
        : [],
    seller: {
      id: product.produtor_id.toString(),
      slug: product.produtor_slug,
      name: product.produtor,
    },
    price: {
      product: parseFloat(product.preco) as number,
      sell: parseFloat(product.preco) as number,
      discount: 0,
    },
    preco_promocional: product.preco_promocional ? parseFloat(product.preco_promocional) : 0,
    preco_promocional_ativo: product.preco_promocional_ativo as boolean,
    days: product.produtor_dias_entrega,
    stock: product.quantidade_estoque,
    national: !!(product.forma_entrega_slug === 'jadlog' || product.forma_entrega_slug === 'retirada-local'),
    tipo_produto: product.tipo_produto,
    categories: product.categorias ? JSON.parse(product.categorias) : [],
    categorias_slug: product.categorias_slug ? product.tags_descricao : [],
    isAfiliadoFavorite: product.isAfiliadoFavorite,
  }
}

// force commit

export function parserExp(exp: FazendinhaProduct): Experience {
  return {
    id: exp.id.toString(),
    assinatura: false,
    slug: exp.slug,
    name: exp.nome,
    description: exp.descricao,
    image: exp.imagem_principal,
    images:
      exp.imagens.length > 0
        ? exp.imagens.map((url) => ({
            url: url !== undefined && url !== null ? url : '',
          }))
        : [],
    seller: {
      id: exp.produtor_id.toString(),
      slug: exp.produtor_slug,
      name: exp.produtor,
    },
    price: {
      product: parseFloat(exp.preco) as number,
      sell: parseFloat(exp.preco) as number,
      discount: 0,
    },
    preco_promocional: parseFloat(exp.preco_promocional) as number,
    preco_promocional_ativo: exp.preco_promocional_ativo as boolean,
    days: exp.produtor_dias_entrega,
    stock: exp.quantidade_estoque,
    national: !!(exp.forma_entrega_slug === 'jadlog' || exp.forma_entrega_slug === 'retirada-local'),
    tipo_produto: exp.tipo_produto,
    experiencias: exp.experiencias,
    categories: [],
    experiencia_entrada: exp.experiencia_entrada,
    experiencia_prato_principal: exp.experiencia_prato_principal,
    experiencia_bebidas: exp.experiencia_bebidas,
    experiencia_sobremesa: exp.experiencia_sobremesa,
    experiencia_transporte: exp.experiencia_transporte,
    experiencia_localizacao: exp.experiencia_localizacao,
    experiencia_aceita_animais: exp.experiencia_aceita_animais,
  }
}
